"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../i18n/i18n");
var _button = require("../../button");
var _menu = require("../../menu");
var _StyledPanelHeaderComponents = require("../styled/StyledPanelHeaderComponents");
const PanelHeader = _ref => {
  let {
    title,
    onBackButtonClick,
    onCloseButtonClick,
    contentBefore,
    kebabMenuComponents,
    children,
    overrides,
    ...otherProps
  } = _ref;
  // Menu handlers for kebab, filter, and sort
  const kebabMenuOpenHelpers = (0, _menu.useMenuOpenState)();
  const {
    getTargetHTMLProps: getKebabMenuTargetHTMLProps,
    getMenuProps: getKebabMenuProps
  } = (0, _menu.useMenu)({
    ...kebabMenuOpenHelpers,
    placement: "bottom-end"
  });
  const {
    i18n
  } = (0, _i18n.useI18n)();
  return /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledPanelHeaderWrapper, otherProps, /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledTopRowWrapper, {
    panelHasChildren: Boolean(children)
  }, /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledLeftButtonWrapper, {
    hasContentBefore: Boolean(contentBefore)
  }, onBackButtonClick && !overrides?.backButton && /*#__PURE__*/_react.default.createElement(_button.Button, {
    size: "small",
    iconBefore: /*#__PURE__*/_react.default.createElement(_ursaIcons.ChevronLeftIcon, {
      size: 20
    }),
    appearance: "secondary-empty",
    onClick: onBackButtonClick,
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the built in 'back' button.",
      id: "Back to previous panel"
    })
  }), overrides?.backButton, contentBefore), /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledTitleWrapper, null, overrides?.title, title && !overrides?.title && /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledTitle, {
    system: "ursa",
    variant: "TT-Norms-Pro--18px--700w",
    lineClamp: 1
  }, title)), /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledRightButtonWrapper, null, !!kebabMenuComponents && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.Button, (0, _extends2.default)({}, getKebabMenuTargetHTMLProps(), {
    size: "small",
    iconBefore: /*#__PURE__*/_react.default.createElement(_ursaIcons.MoreIcon, {
      size: 20
    }),
    appearance: "secondary-empty",
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the 'options' kebab button.",
      id: "More options"
    })
  })), /*#__PURE__*/_react.default.createElement(_menu.Menu, getKebabMenuProps({
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the panel options menu flyout.",
      id: "Panel menu"
    }),
    includeBlanket: true
  }), kebabMenuComponents)), /*#__PURE__*/_react.default.createElement(_StyledPanelHeaderComponents.StyledCloseButton, {
    size: "small",
    iconBefore: /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
      size: 20
    }),
    appearance: "secondary-empty",
    onClick: onCloseButtonClick,
    "aria-label": title ? i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the 'close' button. In this case, there's a title string so this specific message informs the user that it closes this particular panel by title.",
      id: "Close {title}",
      values: {
        title: title
      }
    }) : i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the 'close' button. In this case, there's no title string so this generic message informs the user that it closes the panel.",
      id: "Close Panel"
    })
  }))), children);
};
exports.PanelHeader = PanelHeader;
//# sourceMappingURL=PanelHeader.js.map